import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { LangService } from '../../pathways-ui/services/lang.service';

@Component({
    selector: 'signin-form',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss'],
})
export class SigninComponent implements OnDestroy {
    title = 'pathways-data-works';
    isIframe = false;
    loginDisplay = false;
    private readonly _destroying$ = new Subject<void>();

    registerUsing: 'email' | 'mobile' = 'email';

    constructor(
        private translate: TranslateService,
        private lang: LangService
    ) {}

    ngOnDestroy(): void {}
    async ngOnInit() {
        this.translate.use(this.lang.currentLang);
        this.isIframe = window !== window.parent && !window.opener;
    }

    doClick() {}
}
